export const LIMIT_ATTEMPT_5_TIMES_FR = 555
export const PMO_SEQUENCE_ERROR_CODES = ['ERRSCH40205', 'ERRSCH41205']
